/**
 * User role types.
 */
export enum UserRole {
  Merchant = 'merchant',
  Admin = 'admin',
  User = 'user',
}
